import React from 'react'
import { Button, InputText } from 'primereact'
import { getPersonalById, getPersonalByIdToken } from '../../../../API/RRHH/Personal/PersonalRequests'
import { useState } from 'react'
import { toastShow } from '../../../../Base/Services/ToastService'
import { getNumRespuestasPersonal } from '../../../../API/Gerencia/Procedimientos/Evaluaciones/EvaluacionesRequets'

const SelectPersonalScreen = ({ setPersonal, toast, setLoading, procedimiento }) => {
    console.log(procedimiento);

    const [codigo, setCodigo] = useState('');
    const [persona, setPersona] = useState(null);
    const [NuRespuestas, setNuRespuestas] = useState(0);
    const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZFVzZXIiOjEsIlVzdWFyaW8iOiJVc3VhcmlvIiwiVXNlck5hbWUiOiJVc2VyTmFtZSIsIklkUm9sIjoxLCJSb2wiOiJSb2wiLCJpYXQiOjE2NTc2Mzg1NDV9.9NpKcV5boGkcSTcbZd8_k5w002ncUtBmImymzGUloFY';

    const buscar = async () => {
        setLoading(true);
        const t = await getPersonalByIdToken(codigo.padStart(5, '0'), token);
        if (procedimiento) {
            const n = await getNumRespuestasPersonal(t[0]?.idpersonal, procedimiento?.IdEvaluacion);
            console.log(n);
            if (n.length > 0) {
                setNuRespuestas(n[0].NumRespuestas);
            } else {
                setNuRespuestas(0);
            }
        }
        if (t.length > 0) {
            setPersona(t[0]);
        } else {
            toastShow(toast, 'warn', 'Código de personal no valido.')
            setPersona(null);
        }
        console.log(t);
        setLoading(false);
    }

    const continuar = () => {
        if (procedimiento.VariasRespuestas) {
            setPersonal(persona);
        } else {
            if (NuRespuestas > 0) {
                toastShow(toast, 'warn', 'Este personal ya ha completado la evaluación.')
            } else {
                setPersonal(persona);
            }
        }
    }

    return (
        <div>
            <div className='d-flex' style={{ alignItems: 'center' }}>
                <h5>Ingrese su código de empleado: </h5>
                <InputText className='mx-3' value={codigo} onChange={e => setCodigo(e.target.value)} maxLength={5}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            buscar();
                        }
                    }
                    }
                />
                <Button label='Buscar' onClick={buscar} />
            </div>
            {persona && <div className='mt-5 d-flex' style={{ flexDirection: 'column', alignItems: 'center' }}>
                <h5>Nombre: {persona?.NombreEmpleado} </h5>
                <h5>Sección: {persona?.seccion} </h5>
                <h5>Posición: {persona?.posicion} </h5>
                <h5>Respuestas ingresadas: {NuRespuestas} </h5>
                <Button label='Continuar' onClick={continuar} />
            </div>}

        </div>
    )
}

export default SelectPersonalScreen